var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82:232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8743 19.4614H28.6423V18.0648C28.642 17.8608 28.5318 17.6728 28.3539 17.5728L20.6073 13.2189V11.0023H22.1397V11.8449C22.1397 12.1571 22.3929 12.4103 22.7051 12.4103H27.3248C27.6371 12.4102 27.8901 12.1569 27.8901 11.8446C27.8901 11.7792 27.8786 11.7142 27.8563 11.6526L27.3927 10.3351L27.862 9.04591C27.9682 8.75223 27.8162 8.42809 27.5225 8.32193C27.461 8.29966 27.396 8.28828 27.3305 8.28821H25.227V7.46832C25.227 7.15605 24.9738 6.90287 24.6616 6.90287H20.6073V6.21303C20.6073 5.90076 20.3542 5.64758 20.0419 5.64758C19.7296 5.64758 19.4764 5.90076 19.4764 6.21303V13.2189L11.7298 17.5672C11.552 17.6671 11.4418 17.8551 11.4415 18.0591V19.4558H4.20943C3.89716 19.4558 3.64398 19.7089 3.64398 20.0212V34.8132C3.64398 35.1255 3.89716 35.3787 4.20943 35.3787H35.8743C36.1866 35.3787 36.4398 35.1255 36.4398 34.8132V20.0269C36.4398 19.7146 36.1866 19.4614 35.8743 19.4614ZM25.227 10.4369L25.2044 10.4143V9.44172H26.4936L26.2618 10.1655C26.2155 10.2914 26.2155 10.4297 26.2618 10.5556L26.5275 11.2794H23.2706V11.0023H24.6616C24.9738 11.0023 25.227 10.7492 25.227 10.4369ZM20.6073 8.03376H24.0961V8.87627V9.87146H20.6073V8.03376ZM11.4415 34.2478H4.77487V20.5923H11.4415V34.2478ZM19.4764 34.2478H16.5079V27.7904H19.4764V34.2478ZM23.5759 34.2478H20.6073V27.7904H23.5759V34.2478ZM27.534 34.2478H24.7068V27.225C24.7068 26.9127 24.4536 26.6595 24.1414 26.6595H15.9424C15.6301 26.6595 15.377 26.9127 15.377 27.225V34.2478H12.5497V18.4153L20.0419 14.1971L27.5114 18.3927L27.534 20.0212V34.2478ZM35.3089 34.2478H28.6423V20.5923H35.3089V34.2478Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0419 15.9273C18.7325 15.9304 17.6727 16.9927 17.6727 18.3022C17.6758 19.6107 18.7391 20.6688 20.0476 20.6657C21.3561 20.6626 22.4143 19.5994 22.4112 18.2909C22.408 16.9846 21.3482 15.9273 20.0419 15.9273ZM20.0419 19.5348C19.358 19.5317 18.8062 18.9748 18.8093 18.2909C18.8124 17.6114 19.3624 17.0613 20.0419 17.0582C20.7268 17.0613 21.2803 17.6174 21.2803 18.3022H21.2859C21.2828 18.9861 20.7258 19.538 20.0419 19.5348Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2684 21.8362H6.13751V24.098H7.2684V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0562 21.8362H8.92529V24.098H10.0562V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5304 21.8362H14.2686V22.9671H16.5304V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1728 21.8362H18.911V22.9671H21.1728V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8151 21.8362H23.5533V22.9671H25.8151V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5304 24.4713H14.2686V25.6021H16.5304V24.4713Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1728 24.4713H18.911V25.6021H21.1728V24.4713Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8151 24.4713H23.5533V25.6021H25.8151V24.4713Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2684 26.2863H6.13751V28.548H7.2684V26.2863Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0562 26.2863H8.92529V28.548H10.0562V26.2863Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2684 30.7419H6.13751V33.0037H7.2684V30.7419Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0562 30.7419H8.92529V33.0037H10.0562V30.7419Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1585 21.8362H30.0276V24.098H31.1585V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9462 21.8362H32.8153V24.098H33.9462V21.8362Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1585 26.2863H30.0276V28.548H31.1585V26.2863Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9462 26.2863H32.8153V28.548H33.9462V26.2863Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1585 30.7419H30.0276V33.0037H31.1585V30.7419Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9462 30.7419H32.8153V33.0037H33.9462V30.7419Z",
    fill: "#242731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82:232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7958,
    height: 32.7958,
    fill: "white",
    transform: "translate(3.64398 4.11517)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.3fc32bff6edc90fd89a1808fea595dd2.svg";
export { ForwardRef as ReactComponent };